import CsatByDeviceWidget from './CsatByDeviceWidget';
export default CsatByDeviceWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByDeviceWidget/index.js